import { getFooterData } from '../../selectors';

const getFooterDataSafe = (state) => getFooterData(state) || {};
/* footer selectors */

export const getFooterDataContent = (state) => getFooterDataSafe(state).content || {};
